import { render, staticRenderFns } from "./Scratch_Response.vue?vue&type=template&id=3e71f246&scoped=true"
import script from "./Scratch_Response.vue?vue&type=script&lang=js"
export * from "./Scratch_Response.vue?vue&type=script&lang=js"
import style0 from "./Scratch_Response.vue?vue&type=style&index=0&id=3e71f246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71f246",
  null
  
)

export default component.exports